import { render } from "./SettingsBillingSection.vue?vue&type=template&id=08899cf6"
import script from "./SettingsBillingSection.vue?vue&type=script&lang=js"
export * from "./SettingsBillingSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__